module.exports = __webpack_public_path__ + "static/media/Step5.e978bb84.png";